<template>
	<div class='route_container'>
		<div class="main_container py-5 px-5 mt-5">
			<div class="row">
				<!-- category sidebar -->
				<div class="col-lg-3 filter-column pr-lg-3 px-0">
					<router-link v-if="$store.state.username.length"
							class="btn btn-primary btn-md rounded w-100 text-secondary mb-2"
							:to="`/${$store.state.meta.lang}/discussion/create-new`"
							>							
						<font-awesome-icon :icon='["fa", "plus-circle"]' />&nbsp;
						<span>Add New Discussion</span>
					</router-link>
					<fancy-input
						:placeholder='`${ $t("gifts_search") }...`'
						v-model='searchDiscussion'
						type="text"
						aria-label="Search"
						ref="search"
						:error='errors.search'
						:large='true'
					></fancy-input>
					<ul id="filtersList" class="nav accordion d-flex flex-column flex-nowrap bg-gray-900 border border-green-lighter border-top-0  box-shadow my-3">
						<li class="nav-item py-3">
							<div class="d-flex row align-items-center justify-content-between m-0 px-2">
								<div class="categories-title d-flex row align-items-center col-11">
									<p class="h6 text-white mb-0 py-2">Category</p>
								</div>
							</div>
							<router-link
								v-for='(category, $index) in categories'
								:key='"category-link-" + $index'
								class='threads_main__side_bar__menu_item'
								:to="`/${$store.state.meta.lang}/discussions/${category.value}`"
							>
								<span
									class='threads_main__side_bar__menu_item__border'
								></span>
								<span
									class='threads_main__side_bar__menu_item__text'
								>{{category.name}}</span>
							</router-link>
						</li>
					</ul>
				</div>
				<div class="col-lg-9 pl-lg-3 px-0 pb-3">
					<div class="border border-green-lighter py-3 px-3">
						<div class="d-flex">
							<h2 class="border-bottom border-green-lighter mr-3" style="flex:1"> {{ $t('gifts_discussions') }} </h2>
							<b-dropdown
								:text='`Sort ${ $t("gifts_by") }`'
								size="sm header_dropdown" 
							>
								<b-dropdown-item @click="latest_post()">
									Last Post
								</b-dropdown-item>
								<b-dropdown-item @click="newest_post()">
									{{ $t('gifts_new_2') }}
								</b-dropdown-item>
							</b-dropdown>
						</div>
						<div class="table">
							<div class="table__heading">
								<h6 class="table__heading__width-fill"> Summary </h6>
								<h6 class="table__heading__width-small"> Comments </h6>
								<h6 class="table__heading__width-medium"> {{ sortName }} </h6>
							</div>
							<div v-if="waitLoading" class="table__row-inner-wrap justify-content-center m-auto">
								<loading-button									
									:loading='waitLoading'
									class='nav-link m-auto'
								>
									<font-awesome-icon icon="spinner"/>
								</loading-button>
							</div>
							<div class="table__rows">
								<div class="table__row-outer-wrap" v-for="discussion in drawDiscussions" :key="discussion.id">
									<div class="table__row-inner-wrap">
										<div>
											<router-link 
												:to="`/${$store.state.meta.lang}/user/${discussion.creator}`"
												class="giveaway_image_avatar" 
												:style="discussion.profile_photo_path?
												{ 'background-image': 'url(' +apiDomain+'/uploads/avatar/'+discussion.profile_photo_path + ')' }:
												{ 'background-image': 'url(' + missed_avatar + ')' }"
											>
												<span v-if="discussion.reply_comment_cnt" 
														class="badge badge-danger navbar-badge ml-3">{{ discussion.reply_comment_cnt }}</span>
											</router-link>
										</div>
										<div class="table__column--width-fill">
											<div>
												<p>
													<router-link :to="`/${$store.state.meta.lang}/discussion_detail/${encodeURIComponent(discussion.title)}/${discussion.discussion_id}`">
														{{discussion.title}}
													</router-link>
												</p>
												<small>
													<router-link :to="`/${$store.state.meta.lang}/discussions/` + discussion.category">
														{{discussion.category}}
													</router-link>
													{{ discussion.created_at | localTime | formatDate }} {{ $t('gifts_ago') }} {{ $t("gifts_by") }}
													<router-link :to="`/${$store.state.meta.lang}/user/${discussion.creator}`">
														{{discussion.creator}}
													</router-link>
												</small>
											</div>
										</div>
										<div class="table__column--width-small text-center">											
											{{ discussion.comment_cnt }}
										</div>
										<div v-if="discussion.comment_cnt" class="table__column--width-medium">
											<div>
												{{ discussion.last_comment_date | localTime | formatDate }} {{ $t('gifts_ago') }} {{ $t("gifts_by") }}
												<router-link :to="`/${$store.state.meta.lang}/user/${discussion.last_comment_user.username}`">
													{{discussion.last_comment_user.username}}
												</router-link>
											</div>
											<router-link 
												:to="`/${$store.state.meta.lang}/user/${discussion.last_comment_user.username}`"
												class="giveaway_image_avatar" 												
												:style="discussion.last_comment_user.profile_photo_path?
												{ 'background-image': 'url(' +apiDomain+'/uploads/avatar/'+discussion.last_comment_user.profile_photo_path + ')' }:
												{ 'background-image': 'url(' + missed_avatar + ')' }"
											>
											</router-link>
										</div>
										<div v-else class="table__column--width-medium">
											<div>--</div>
											<router-link 
												to=""
												class="giveaway_image_avatar" 												
												:style="{ 'background-image': 'url(' + missed_avatar + ')' }"
											>
											</router-link>
										</div>
									</div>
								</div>
								<div class="col-12 text-center text-danger" v-if="!waitLoading && drawDiscussions && !drawDiscussions.length">
									<h6>{{ $t('gifts_no_results') }}</h6>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import FancyInput from '../FancyInput'
	import {apiDomain} from '../../config'
	import LoadingButton from '../LoadingButton';

	export default {
		name: 'discussions',
		components: {
			FancyInput,
			LoadingButton
		},
		data () {
			return {
				apiDomain: apiDomain,
				hero_img: require("./../../assets/img/new-home/header.jpg"),
				choosed_color: "#00ff7f",
				choosed_back_color: "#00ff7f",
				waitLoading: false,
				categories: [
					{ "name": "All", "value": ""},
					{ "name": "Add-ons / Tools", "value": "addons-tools"}, 
					{ "name": "Announcements", "value": "announcements"},
					{ "name": "Bugs / Suggestions", "value": "bugs-suggestions"},
					{ "name": "Deals", "value": "deals"},
					{ "name": "Game Showcase", "value": "game-showcase"},
					{ "name": "General", "value": "general"},
					{ "name": "Group Recruitment", "value": "group-recruitment"},
					{ "name": "Hardware", "value": "hardware"},
					{ "name": "Help", "value": "help"},
					{ "name": "Let's Play Together", "value": "lets-play-together"},
					{ "name": "Movies / TV", "value": "movies-tv"},
					{ "name": "Off Topic", "value": "off-topic"},
					{ "name": "Puzzles / Events", "value": "puzzles-events"},
					{ "name": "Uncategorized", "value": "uncategorized"},
					{ "name": "User Projects", "value": "user-projects"},
					{ "name": "Whitelist Recruitment", "value": "whitelist-recruitment"}
				],
				searchDiscussion: "",
				sortName: "Newest",
				missed_avatar: require("./../../assets/img/new-home/missed_avatar.jpg"),
				drawDiscussions:[],
				errors:{
					search: false
				}
			}
		},
		created(){
			//All discussionss
			this.waitLoading = true;
			this.axios.request({
				method: 'GET',
				url: `${apiDomain}/api/v1/discussions/full`,
				data: {},
				headers: {
					'Authorization': `Bearer ${this.$cookies.get('authtoken')}`
				}
			}).then(res => {
				this.waitLoading = false;
				
				this.$store.commit('setDiscussions', res.data);				

				let cName = this.$route.params.category && this.$route.params.category.toLowerCase();

				this.drawDiscussions = !!cName ? res.data.filter( x => x.category===cName ) : res.data;

			}).catch(err => {				
				this.waitLoading = false;						
				console.log(err)
			})		
			
		},
		watch: {
			searchDiscussion: function(skey){
				this.drawDiscussions = this.$store.state.meta.discussions.filter(x => x.title.toLowerCase().includes(skey.toLowerCase()) )

				this.drawDiscussions.length ? this.errors.search = '' : (this.errors.search = this.$t("gifts_no_results"));
			},
			'$route.params.category': function(cName){
				
				this.drawDiscussions = (!cName || cName=='all') ? this.$store.state.meta.discussions : 
															this.$store.state.meta.discussions.filter( x => x.category===cName.toLowerCase());
			}
		},
		methods: {
			latest_post: function(){
				
				this.drawDiscussions = this.drawDiscussions.slice().sort( (a, b) => {					
					var dateA = new Date(a.created_at), dateB = new Date(b.created_at);
					return dateB - dateA
				});
				this.sortName = "Last Post";
			},
			newest_post: function(){
				
				this.drawDiscussions = this.drawDiscussions.slice().sort( (a, b) => {					
					var dateA = new Date(a.created_at), dateB = new Date(b.created_at);
					return dateA - dateB
				});

				this.sortName = "Newest";
			}
		}
	}
</script>

<style lang='scss' scoped>
	@import '../../assets/scss/elementStyles.scss';
	@import '../../assets/scss/variables.scss';
	@import '../../assets/scss/idec.scss';

	.router-link-exact-active span:first-child {
		background-color: $color__green--primary;
	}

	.router-link-exact-active span:last-child {
		color: $color__green--primary;
	}

	.threads_main {
		display: flex;

		&__side_bar{
			width: 12rem;
			height: 0%;
			background: #fff;
			margin-right: 1rem;
			border-radius: 0.25rem;
			border: thin solid $color__gray--darker;
			padding: 0.5rem 0 1rem 1rem;
			position: sticky;
			top: 4.5rem;

			@at-root #{&}__title {
				color: $color__darkgray--darker;
				cursor: default;
				font-weight: 500;
				font-size: 1.125rem;
			}

			@at-root #{&}__menu_item {
				cursor: pointer;
				margin-top: 0.5rem;
				position: relative;
				display: grid;
				grid-template-columns: 0.75rem auto;
				grid-column-gap: 1rem;
				text-decoration: none;
				background-image: none;
				font-weight: normal;
				margin-left: 1.5rem;

				span{
					color: #fff;
				}

				@at-root #{&}__border {
					align-self: center;
					display: inline-block;
					height: 0.9rem;
					width: 0.9rem;
					border-radius: 0.5rem;
					margin-top: 0;
					background-color: $color__gray--darkest;
					transition: all 0.2s;
				}

				@at-root #{&}__text {
					filter: saturate(0.75), brightness(0.75);
				}


				@at-root #{&}--selected {
					font-weight: 600;
				}
			}
		}

		&__load_new{
			@extend .button;

			font-size: 1.25rem;
			margin: 0 0 1rem 0;
			background-color: $color__lightgray--primary;
			border-color: $color__gray--darker;
			width: 100%;
			font-weight: 300;
		}
	}

	.table__heading {
		display: flex;
		min-height: 32px;
		align-items: center;
		font-size: 11px;
		margin-top: 1rem;
		margin-bottom: 1rem;
		font-weight: bold;
		color: #fff;
		border-bottom: 1px solid rgba(0, 255, 126, 0.25);

		&__width-fill{
			flex: 1;
		}

		&__width-small{
			width: 13%;
    		min-width: 90px;
			text-align: center;
		}

		&__width-medium{
			width: 21%;
    		min-width: 120px;
			text-align: right;
		}
	}

	.table__row-outer-wrap{
		padding: 10px 0;
		border-right: 1px solid transparent;
		border-left: 1px solid transparent;
		font-size: 14px;
		border-bottom: 1px solid #d2d6e0;

		.table__row-inner-wrap{
			display: flex;
			align-items: center;
			line-height: 1.3em;
			color: #fff;

			&>*:not(:last-child){
				padding-right: 1rem;
			}

			.table__column--width{
				&-fill{
					flex: 1;
				}
				&-small{
					width: 13%;
					min-width: 90px;
				}
				&-medium{
					width: 21%;
					min-width: 120px;
					display: flex;
					align-items: center;

					div{
						flex: 1;
					}
				}
			}
		}
	}

	@media (max-width: $breakpoint--tablet) {
		.main_container{
			margin-top: 0!important;
		}
		.threads_main__side_bar {
			display: none;
		}
		.threads_main__threads {
			width: 100%;
			margin-left: 0;
		}
		.table__row-outer-wrap{
			overflow-x: auto;
			
			.table__row-inner-wrap{
				min-width: 600px;
			}
		}
	}
</style>
